import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTimeline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.75 6.5C2.75 4.42893 4.42893 2.75 6.5 2.75H17.5C19.5711 2.75 21.25 4.42893 21.25 6.5V17.5C21.25 19.5711 19.5711 21.25 17.5 21.25H6.5C4.42893 21.25 2.75 19.5711 2.75 17.5V6.5ZM6.5 4.25C5.25736 4.25 4.25 5.25736 4.25 6.5V17.5C4.25 18.7426 5.25736 19.75 6.5 19.75H17.5C18.7426 19.75 19.75 18.7426 19.75 17.5V6.5C19.75 5.25736 18.7426 4.25 17.5 4.25H6.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 7.75C6 7.33579 6.33579 7 6.75 7H13.75C14.1642 7 14.5 7.33579 14.5 7.75C14.5 8.16421 14.1642 8.5 13.75 8.5H6.75C6.33579 8.5 6 8.16421 6 7.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 15.75C9 15.3358 9.33579 15 9.75 15H16.75C17.1642 15 17.5 15.3358 17.5 15.75C17.5 16.1642 17.1642 16.5 16.75 16.5H9.75C9.33579 16.5 9 16.1642 9 15.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25 11C7.83579 11 7.5 11.3358 7.5 11.75C7.5 12.1642 7.83579 12.5 8.25 12.5H15.25C15.6642 12.5 16 12.1642 16 11.75C16 11.3358 15.6642 11 15.25 11H8.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconTimeline as ReactComponent };
